import axios from "axios";
import qs from "qs";
import * as actionType from "../../../constant/actionType";

export const GenerateWeeklyClosureReport = (params = {}) => async () => {
  try {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    const response = await axios({
      method: "get",
      url: `${actionType.environment_url}/api/admin/GenerateWeeklyClosureReport`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
        organisationid: storedData?.organisation_id,
      },
      params,
      paramsSerializer: (payload) =>
        qs.stringify(payload, { arrayFormat: "repeat", skipNulls: true }),
    });

    return response.data;
  } catch (error) {
    return error?.response?.data ?? { success: false, message: error.message };
  }
};
